import cloneDeep from 'lodash.clonedeep';

import { FormalityState } from '@core/store/formality/formality-reducer';
import { AppStoreState } from '@interfaces/app-store-state';

export const formalitySelector = (state: AppStoreState): FormalityState =>
  state && state.formality ? cloneDeep(state.formality) : null;
